import { useEffect, useState } from 'react';

export const DEFAULT_DEFERRED_LOADING_DELAY = 250;

export function useDeferredLoading(loading: boolean, delay = DEFAULT_DEFERRED_LOADING_DELAY) {
  const [deferredLoading, setDeferredLoading] = useState(false);

  useEffect(() => {
    if (!loading) {
      return;
    }

    const timeoutId = window.setTimeout(() => {
      setDeferredLoading(true);
    }, delay);

    return () => {
      clearTimeout(timeoutId);
      setDeferredLoading(false);
    };
  }, [loading, delay]);

  return loading && deferredLoading;
}
